let content = [
    {
      id: "general_trading_conditions",
      title: "Algemene handelscondities",
      tabs: [
        {
          //id: "product_details",
          id:"tc-view-6",
          title: "Productdetails",
          content_before: `<p class="mb-5">
                          iFOREX Europe biedt zeer concurrerende voorwaarden voor de volgende financiële instrumenten ("Financiële Instrumenten" of "Instrumenten") (i) beleggen met marge met hefboomwerking in financiële instrumenten / onderliggende activa ("Onderliggende Activa") met inbegrip van een Valutapaar (Forex), Grondstof, Index, Aandeel, ETF en Crypto op basis van CFD's ("Instrumenten met hefboomwerking" of "CFD's").
                          <br><br>
                          <b>Spreads</b><br>De kosten voor het openen van een transactie worden de 'spread' genoemd. Het is het verschil tussen de verkoop (bied) prijs en de koop(vraag) prijs. Bijvoorbeeld, als de USD/JPY wordt verhandeld bij een verkoopprijs van 101.202 en een koopprijs van 101.222, dan wordt het verschil tussen deze twee prijzen de spread genoemd. In dit geval bedraagt de spread twee pips. Mocht je besluiten om een transactie te sluiten onmiddellijk nadat je hem hebt geopend - en voordat er enige prijswijziging plaatsvindt - dan wordt het bedrag van de spread van je saldo afgehaald.
                          <br><br>
                          <b>Marge en Hefboom</b><br>Terwijl de "Marge" optreedt als onderpand voor het dekken van enige verliezen die u zou kunnen oplopen, stelt het u tevens in staat om een positie vast te houden die veel groter is dan uw werkelijke accountwaarde, waardoor u de kans krijgt om grote winst te genereren ten opzichte van het geïnvesteerde bedrag.
                          <br><br>
                          Hefboom snijdt aan twee kanten en kan uw winst ingrijpend vergroten, maar het kan net zo gemakkelijk uw verlies vergroten. Wanneer u teveel gebruikmaakt van hefboom, kunnen verliestransacties snel vele winsttransacties tenietdoen. Handel met hefboom draagt een hoge mate van risico met zich mee en is wellicht niet geschikt voor alle investeerders.
                          <br><br>
                          Als iFOREX Europe-rekeninghouder hebt u recht op ons beschermingsprogramma voor negatief saldo, wat betekent dat u nooit meer kunt verliezen dan u hebt gestort; desalniettemin kan een kleine marktbeweging leiden tot een aanzienlijk verlies van geld. Ons handelsplatform berekent automatisch uw margevereisten voordat enige order wordt uitgevoerd, en controleert de hoeveelheid beschikbaar geld voordat enige verzoeken om geld op te nemen worden gedaan.
                          <br><br>
                          De margevereisten zijn relevant na toenemende blootstelling in de account, door het openen/sluiten van transacties of door het verzoeken om geld op te nemen terwijl men open posities in de account heeft.
                          </p>
                            <span id="product_section"></span>
                            <p class="tc-inner-link"><a href="/trading-conditions/currencies">Valuta</a></p>
                            <p class="tc-inner-link"><a href="/trading-conditions/commodities">Grondstoffen</a></p>
                            <p class="tc-inner-link"><a href="/trading-conditions/indices">Indices</a></p>
                            <p class="tc-inner-link"><a href="/trading-conditions/shares">Aandelen</a></p>
                            <p class="tc-inner-link"><a href="/trading-conditions/etfs">ETFs</a></p>
                            <p class="tc-inner-link"><a href="/trading-conditions/crypto">Cryptovaluta</a></p>`,
  
          data_id: "",
          content_after: "",
        },
        {
          //id: "trading_hours",
          id: "tc-view-2",
          title: "Handelstijden",
          content_before: `<p>
          Gedurende de Europese en Noord-Amerikaanse winter, begint de wekelijkse activiteit op zondag om 22:05 GMT, ononderbroken tot vrijdag om 21:00 GMT. Gedurende de zomertijd in deze regio's, begint de wekelijkse marktactiviteit op zondag om 21:05 GMT en eindigt op vrijdag om 20:00. Marktactiviteittijden kunnen variëren vanwege feestdagen of als gevolg van ongebruikelijke liquiditeitscondities die kunnen ontstaan uit uitzonderlijke mondiale gebeurtenissen. Openings- of sluitingstijden kunnen tevens worden gewijzigd door iFOREX Europe als gevolg van overwegingen van liquiditeit of risicobeheer.
              <br><br>
              Hoewel de meeste instrumenten op basis van 24 uur en zonder onderbreking worden verhandeld, hebben sommige instrumenten echter speciale handelstijden zoals men kan zien in de onderstaande tabel:
              </p>`,
  
          data_id: "TradingHours",
          products: {
            1:"Valuta & Cryptocurrency",
            2:"Grondstoffen",
            3:"Indexen",
            4:"Aandelen",
            5:"Precious Metals Spot",
            8:"ETFs"
          },
          table_titles: [
            "Markt",
            "Handelstijden (GMT)",
            "1ste dagelijkse onderbreking Tijd (GMT)",
            "2de dagelijkse onderbreking Tijd (GMT)",
            "Gegevens geldig tot (GMT)"
          ],
          content_after: `<p>Weet u niet zeker welke markt het instrument bevat waar u naar op zoek bent? Klik <span class="tclink" target-tab="tc-view-6">hier</span> voor een volledige lijst met instrumenten per markt.</p>`,
        },
        {
          //id: "holidays",
          id: "tc-view-4",
          title: "Vakantiedagen",
          content_before: `<p>
          Om ervoor te zorgen dat u zich bewust bent van alle markttijden en vakantiedagen, vindt u hieronder een lijst met evenementen die de handelstijden zouden kunnen wijzigen.
          <br>
          Wij bij iFOREX Europe doen ons allerbest om deze informatie up-to-date te houden.
          <br>
          Indien u meer informatie wilt ontvangen, neem dan gerust contact op met onze transactiebalie.
              </p>`,
  
          data_id: "Holidays",
          table_titles: [
            "Markt",
            "Handel stoppen om (GMT)",
            "Handel hervatten om (GMT)",
          ],
          content_after: `<p class="mt-4">Weet u niet zeker welke markt het instrument bevat waar u naar op zoek bent? Klik <span class="tclink" target-tab="tc-view-6">hier</span> voor een volledige lijst met instrumenten per markt.</p>`,
        },
        {
          //id: "orders_and_execution",
          id: "tc-view-23",
          title: "Orders en uitvoering",
          content_before: `<p><b>Soorten orders</b></p>
          <table class="mb-4 table4">
             <tbody>
                <tr>
                   <th>MARKTORDERS</th>
                   <th></th>
                </tr>
                <tr>
                   <td>Deal openen</td>
                   <td>Een order om een positie te openen tegen de momenteel beschikbare marktkoers</td>
                </tr>
                <tr>
                   <td>Deal sluiten</td>
                   <td>Een order om een positie te sluiten tegen de momenteel beschikbare marktkoers</td>
                </tr>
             </tbody>
          </table>
          <table class="mb-4 table4">
             <tbody>
                <tr>
                   <th>LIMIETORDERS</th>
                   <th></th>
                </tr>
                <tr>
                   <td>Stop Loss</td>
                   <td>De stop loss is een order om een deal te openen of te sluiten tegen een koers die lager is dan de huidige marktkoers.</td>
                </tr>
                <tr>
                   <td>Take Profit</td>
                   <td>De take profit is een order om een deal te openen of te sluiten tegen een koers die hoger is dan de huidige marktkoers.</td>
                </tr>
             </tbody>
          </table>
          <p>
             <b>Marktorders</b><br>Marktorders (beleggingsverzoeken zoals het openen en sluiten van een transactie) worden uitgevoerd tegen de op het beleggingsplatform van kracht zijnde koerswaarde (client side) op het exacte tijdstip van uitvoeren, op voorwaarde dat een dergelijke koerswaarde tussen het vastgelegde tolerantieniveau van de onderliggende vernieuwde koerswaarde op de servers van het Bedrijf ligt, ongeacht of de onderliggende koerswaarde hoger of lager ligt dan de vernieuwde koerswaarde in het beleggingsplatform (What You See Is what You Get, of WYSIWYG). Indien de bijgewerkte koerswaarde in het platform (client) het bovengenoemde tolerantieniveau overschrijdt, bijvoorbeeld door bewegingen in de onderliggende waarde tussen het tijdstip waarop een client een order heeft geplaatst en de tijd waarop de order wordt ontvangen en uitgevoerd, hoge volatiliteit in de markt en communicatie latency, wordt de order uitgevoerd tegen de in de servers van het bedrijf bijgewerkte koerswaarde, die afwijkt van de in het beleggingsplatform bijgewerkte koerswaarde (Market Price), op een symmetrische basis. In het geval van een wezenlijk verschil tussen de bijgewerkte koerswaarde in het beleggingsplatform (client side) en de bijgewerkte koerswaarde in de servers van het bedrijf, wordt de order afgewezen.
          </p>
          <p>
             <b>Limietorders</b><br>Limietorders (toekomstige orders) worden uitgevoerd tegen de op de servers van het bedrijf bijgewerkte koerswaarde, die anders kan zijn dan de in de Order ( "Slippage") genoemde koerswaarde kan zijn. Slippage kan optreden wanneer de de koerswaarde van de order niet beschikbaar is in de servers, bijvoorbeeld vanwege de hoge volatiliteit en gaten in de marktkoersen. In dat geval zal de order worden uitgevoerd bij de eerste beschikbare koerswaarde, ongeacht de richting van de slippage, hetzij in het voordeel of niet in het voordeel van de klant, in een symmetrische en transparante wijze (Symmetrical Slippage).<br><br>Instrumenten (zoals aandelen en indexen) die niet 24 uur per dag kunnen worden verhandeld, kunnen dagelijks onderhevig zijn aan gaten in de marktkoersen. Om deze reden treedt slippage vaker op bij deze instrumenten. Het is belangrijk om te weten dat slippage geen effect heeft op de bescherming tegen een negatief saldo. De Client zal dus nooit meer geld verliezen dan het bedrag dat is geïnvesteerd (inclusief eventuele winsten), zelfs wanneer er sprake is van slippage.<br><br>Let op! Wanneer de klant een Limit Order heeft op een openstaande transactie dan kunnen een aantal van deze of al deze transacties automatisch worden gesloten voordat de respectievelijke limieten zijn bereikt. Dit komt door de wettelijk verplichte automatische sluitingsbescherming. Voor meer informatie over verplichte marge en het verplicht automatische sluiten van transacties klikt u op de tab "Marge informatie" hierboven.
          </p>
          <p>
             <b>Vertragingen in uitvoering</b><br>Een vertraging in de uitvoering kan om diverse redenen optreden, zoals technische problemen met het internet, mobiele of andere communicatieverbinding van de klant met de iFOREX Europe-servers, wat kan leiden tot “hangende orders”. Een verstoring in het verbindingspad kan soms het signaal onderbreken en het platform uitschakelen, wat vertragingen veroorzaakt in gegevenstransmissie tussen het platform van de handelaar en de iFOREX Europe-server.
          </p>
          <p>
             <b>Hangende orders</b><br>Tijdens periodes van hoge handelsvolumes of communicatielatentie, kunnen hangende orders (een wachtrij van limietorders) optreden. Die toename van binnenkomende orders kan soms condities creëren met een vertraging in het bevestigen/verwerken van bepaalde limietorders. In sommige gevallen kan de positie in feite zijn uitgevoerd en de vertraging is eenvoudigweg aan de zijde van de klant als gevolg van hoge volumes van internetverkeer.<br><br>Denk eraan dat elke order slechts eenmaal ingevoerd hoeft te worden. Meerdere invoeren voor dezelfde order kunnen uw computer vertragen of vergrendelen of ongewenste posities onbedoeld openen.
              </p>`,
  
          data_id: "",
          content_after: "",
        },
        {
          //id: "negative_balance_protection",
          id: "tc-view-20",
          title: "Bescherming tegen negatief saldo",
          content_before: `<p>
                    Het beleid van iFOREX Europe betreffende bescherming van negatief saldo garandeert dat de verliezen van de klant beperkt zijn tot het geïnvesteerde geld op de account van de klant. Volgens dit beleid zal de klant nooit te maken hoeven te hebben met een debetsaldo als gevolg van handelsverliezen bij het handelen bij iFOREX Europe en de potentiële verliezen van de klant zullen beperkt zijn tot het op de account van de klant gestorte geld en, indien aanwezig, tot het geld dat is verworven door de klant.
                            </p>`,
          data_id: "",
          content_after: "",
        },
       {
  //id: "margin_information",
  id: "tc-view-24",
  title: "Marge-informatie",
  content_before: `
    <p>
      Het onderstaande venster toont gedetailleerde informatie met betrekking tot de marge van een account:
      <div class="table-wrapper">
        <table class="table3 mt-4 mb-4">
          <tbody>
            <tr>
              <td>Actueel vermogen</td>
              <td>€4.995</td>
            </tr>
            <tr>
              <td>Gebruikte marge</td>
              <td>€2.500</td>
            </tr>
            <tr>
              <td>Beschikbare marge</td>
              <td>€2.495</td>
            </tr>
            <tr>
              <td>Margegebruik</td>
              <td style="color:green">50,05%</td>
            </tr>
            <tr>
              <td>Onderhoudsmarge</td>
              <td>€1.250</td>
            </tr>
            <tr>
              <td>Netto blootstelling</td>
              <td>€250.000</td>
            </tr>
            <tr>
              <td>Totale marge</td>
              <td>1,498%</td>
            </tr>
          </tbody>
        </table>
      </div>

      <ul class="list-style-disc-small mb-3">
        <li>
          <b>Actueel vermogen</b> weerspiegelt de realtime waarde van uw account. Het omvat uw saldo en de winst/verlies van openstaande posities.
        </li>

        <li>
          <b>Gebruikte marge</b> geeft het bedrag van het actueel vermogen weer dat momenteel wordt gebruikt als marge voor uw openstaande posities. Wanneer de gebruikte marge gelijk is aan of groter is dan het eigen vermogen, betekent dit dat de hefboom maximaal wordt benut.
        </li>

        <li>
          <b>Beschikbare marge</b> geeft het deel van het eigen vermogen weer dat momenteel niet wordt gebruikt en beschikbaar is voor een verdere verhoging van de netto blootstelling. Wanneer de beschikbare marge nul is, betekent dit dat de maximale hefboom wordt gebruikt.<br>
          Beschikbare marge = actueel vermogen – gebruikte marge
        </li>

        <li>
          <b>Margegebruik</b> geeft het percentage van het eigen vermogen weer dat als marge wordt gebruikt voor de huidige openstaande posities van het account. Een margegebruik van 100% of meer betekent dat de maximale hefboom wordt gebruikt.<br>
          Margebruik % = (gebruikte marge / actueel vermogen) × 100
        </li>

        <li>
          <b>Onderhoudsmarge</b> is gelijk aan 50% van de gebruikte marge die vereist is om uw openstaande posities te behouden. Als uw actueel vermogen tot dit niveau daalt of daaronder komt, wordt automatisch de bescherming tegen margin close-out geactiveerd (zoals hieronder gedefinieerd).<br>
          Onderhoudsmarge = Gebruikte marge × 0,5
        </li>

        <li>
          <b>Totale marge</b> is het percentage van de blootstelling dat door middelen wordt gedekt. Deze weerspiegelt de maximale koerswijziging tegen de richting van de openstaande posities, die door middelen worden ondersteund (totdat de onderhoudsmarge wordt bereikt).<br>
          Totale marge = (actueel vermogen – onderhoudsmarge) / netto blootstelling
        </li>
      </ul>

      <b>Margin close-out bescherming</b><br>
      Wanneer de beschikbare middelen in het actueel vermogen van een klant gelijk zijn aan of lager zijn dan de onderhoudsmarge, zal iFOREX Europe automatisch de positie met de grootste hoeveelheid gebruikte marge sluiten, om de laagst mogelijke onderhoudsmarge te bereiken (waarbij alleen openstaande posities worden gesloten op instrumenten die op dat moment open zijn volgens de gepubliceerde handelstijden). Als er op dat moment geen openstaande posities zijn op instrumenten die open zijn, wordt automatisch de positie gesloten op het instrument dat als eerste een koers ontvangt. Wanneer er meerdere posities zijn (meer dan één) die in gelijke mate de grootste hoeveelheid gebruikte marge verbruiken, zal het bedrijf automatisch de positie sluiten die als eerste is geopend. Als de laagst mogelijke onderhoudsmarge niet kan worden bereikt door het automatisch sluiten van slechts één positie, zal het bedrijf automatisch alle openstaande posities sluiten in een specifiek instrument. iFOREX Europe staat klanten toe de niet-gerealiseerde winsten uit hun openstaande posities volledig te gebruiken om verlieslatende posities te ondersteunen.
      <br><br>

      <b><u><u>Voorbeelden</u></u></b><br><br>

      <b>Voorbeeld I</b><br>
      Dit voorbeeld beschrijft een situatie waarin een klant meerdere posities open heeft en het actueel vermogen op het account gelijk is aan of lager is dan de onderhoudsmarge:<br><br>
      <ul class="list-style-disc-small mb-3">
        <li>Openstaande posities:</li>
        <ul class="list-style-disc-small empty-disc ml-4">
          <li>1 EUR/USD-transactie: KOOP €60.000 @ koers 1,1750 (Initiële vereiste marge = 3,33% × €60.000 = €1.998)</li>
          <li>1 Germany 40-transactie: KOOP 4 contracten @ koers 12.500 (Initiële vereiste marge = 5% × 4 × €12.500 = €2.500)</li>
          <li>1 WTI-olietransactie: KOOP 500 vaten @ koers 70,00 (59,56 euro) (Initiële vereiste marge = 10% × 500 × €59,56 = €2.978)</li>
        </ul>
        <li>Gebruikte marge = €1.998 + €2.500 + €2.978 = €7.476</li>
        <li>Onderhoudsmargeniveau = €3.738</li>
      </ul>
      Zodra het actueel vermogen gelijk is aan of lager is dan €3.738, wordt de margin close-out bescherming geactiveerd door de positie met de grootste gebruikte marge te sluiten, namelijk de <b>KOOP van 500 vaten WTI-olie</b>.
      <br><br>

      <b>Voorbeeld II</b><br>
      Dit voorbeeld beschrijft een situatie waarin een klant meerdere posities open heeft en het actueel vermogen gelijk is aan of lager is dan de onderhoudsmarge:<br><br>
      <ul class="list-style-disc-small mb-3">
        <li>Openstaande posities:</li>
        <ul class="list-style-disc-small empty-disc ml-4">
          <li>2 USD/JPY-posities: KOOP $100.000 (Initiële vereiste marge = 3,33% × $100.000 = $3.330), VERKOOP $80.000 (Initiële vereiste marge = 3,33% × $80.000 = $2.664)</li>
          <li>1 USD/PLN -positie: VERKOOP $80.000 (Initiële vereiste marge = 5% × $80.000 = $4.000)</li>
        </ul>
        <li>Gebruikte marge = ($3.330 – $2.664) + $4.000 = $4.666</li>
        <li>Onderhoudsmargeniveau = $2.333</li>
      </ul>
      Zodra het actueel vermogen gelijk is aan of lager is dan $2.333, wordt de margin close-out bescherming geactiveerd door de positie met de grootste gebruikte marge te sluiten, namelijk de <b>VERKOOP $80.000 USD/PLN</b>.
      <br><br>
      Let op:<br><br>
      <ul class="list-style-disc-small mb-3">
        <li>Het sluiten van de VERKOOP $80.000 USD/JPY zou de netto-blootstelling op USD/JPY verhogen van $20.000 naar $100.000, waardoor de <b>gebruikte marge zou toenemen met $2.664 ⇾</b> ($100.000 × 3,33%) − ($20.000 × 3,33%) = $3.330 − $666 = <u>+$2.664</u></li>
        <li>Het sluiten van de KOOP $100.000 USD/JPY zou de netto-blootstelling op USD/JPY verhogen van $20.000 naar $80.000, waardoor de <b>gebruikte marge zou toenemen met $1.998 ⇾</b> ($80.000 × 3,33%) − ($20.000 × 3,33%) = $2.664 − $666 = <u>+$1.998</u></li>
        <li>Het sluiten van de VERKOOP $80.000 USD/TRY zou de netto-blootstelling op USD/TRY verlagen van $80.000 naar 0, waardoor de <b>gebruikte marge zou afnemen met $4.000</b></li>
      </ul>

      <b>Voorbeeld III</b><br>
      Dit voorbeeld beschrijft een situatie waarin een klant meerdere openstaande posities heeft, maar de laagst mogelijke onderhoudsmarge niet kan worden bereikt door het automatisch sluiten van slechts één positie:<br><br>
      <ul class="list-style-disc-small mb-3">
        <li>Openstaande posities:</li>
        <ul class="list-style-disc-small empty-disc ml-4">
          <li>3 USD/JPY-transacties: KOOP $100.000 (Initiële vereiste marge = 3,33% × $100.000 = $3.330), VERKOOP $70.000 (Initiële vereiste marge = 3,33% × $70.000 = $2.331), VERKOOP $10.000 (Initiële vereiste marge = 3,33% × $10.000 = $333).</li>
          <li>2 USD/PLN-transacties: VERKOOP $10.000 (Initiële vereiste marge = 5% × $10.000 = $500), KOOP $8.000 (Initiële vereiste marge = 5% × $8.000 = $400)</li>
          <li>2 USD/INR-transacties: VERKOOP $10.000 (Initiële vereiste marge = 5% × $10.000 = $500), KOOP $7.000 (Initiële vereiste marge = 5% × $7.000 = $350)</li>
        </ul>
        <li>Gebruikte marge = ($3.330 − $2.331 − $333) + ($500 − $400) + ($500 − $350) = $916</li>
        <li>Onderhoudsmarge = $458</li>
      </ul>
      In dit geval zullen, zodra het actueel vermogen gelijk is aan of lager is dan $458, de posities in de rekening automatisch worden gesloten op instrumentniveau, op basis van het instrument met de hoogste netto-blootstelling. Daarom worden <b>alle USD/JPY-posities</b> gesloten.
      <br><br>
      Let op:<br><br>
      <ul class="list-style-disc-small mb-3">
        <li>Het sluiten van een van de transacties zou de netto-blootstelling verhogen; daardoor zou de <b>gebruikte marge toenemen</b>.</li>
        <li>Het sluiten van alle USD/JPY-transacties zal de netto-blootstelling met $20.000 verlagen; daardoor neemt de <b>gebruikte marge af met $666</b>, wat groter is dan bij het sluiten van USD/PLN-transacties (−$100) of USD/INR-transacties (−$150).</li>
      </ul>
    </p>
  `,
  data_id: "",
  content_after: ""
},
        {
          //id: "additional_trading_rules",
          id: "tc-view-25",
          title: "Aanvullende handelsregels",
          content_before: `
              <p>
              <b>Maximumblootstelling</b><br>
                Bij wijze van voorzorg gericht op beter risicobeheer en het vermijden van teveel blootstelling aan één enkele klant, heeft iFOREX Europe een maximum netto blootstellingbeperking ingesteld van tot 12 (twaalf) miljoen euro per klant. iFOREX Europe heeft tevens een maximum netto blootstelling per instrument ingesteld. Voor het weergeven van de maximum blootstelling per instrument, <span class="tclink" target-tab="tc-view-6" target-section="product_section">klikt u hier</span>. iFOREX Europe heeft het recht om een dergelijke beperking op enig moment en zonder voorgaande kennisgeving naar eigen goeddunken te annuleren of te wijzigen.
                <br><br>
                <b>Hedging</b><br>
                Hedging wordt gedefinieerd als de opening van twee transacties op hetzelfde instrument of onderliggende activum bij verschillende richtingen (één "kopen" en de andere "verkopen"), wel of niet op hetzelfde moment en wel of niet voor dezelfde hoeveelheid. iFOREX Europe beschouwt hedging-transacties voor het doel van het berekenen van de minimummarge op cumulatieve basis of op "netto" basis. Bovendien beschouwt iFOREX Europe de sluiting van één van de gedekte transacties als de opening van een nieuwe transactie met bedragen die gelijk zijn aan het bedrag van de resterende transactie.
                <br><br>
                <b>Salderen van transacties</b><br>
                In het geval waar meerdere deals tegelijkertijd moeten worden gesloten in een account, sluit iFOREX Europe alle open posities als bulk.<br>Het transactienummer dat is toegewezen op elke gesloten positie, wordt ingesteld gebaseerd op FIFO-regels. Dit betekent dat de eerst geopende positie, na sluiting van de posities, het laagste transactienummer krijgt en de laatst geopende positie krijgt het hoogste transactienummer.
                <br><br>
                <b>Ongeoorloofde handelspraktijken</b><br>
                iFOREX Europe ondersteunt eerlijk handelen en staat geen ongeoorloofde handelspraktijken of andere praktijken toe die corrupte transacties uitvoeren, zoals: vertraagd handelen, prijsmanipulatie, tijdsmanipulatie of andere praktijken die illegaal zijn en/of gebruikt worden om een oneerlijk voordeel te verkrijgen. Enkele (maar niet alle bestaande) voorbeelden van dergelijke ongeoorloofde handelspraktijken zijn:
                <ul class="list-style-disc-small mt-3 mb-2">
                    <li>
                      <b>Scalping</b> is een handelsstrategie waarbij men kleine prijsveranderingen probeert te benutten. Handelaren die deze strategie toepassen, creëren veel kortetermijnposities en sluiten deze meestal binnen enkele seconden of minuten.
                    </li>
                    <li>
                      <b>Automatisering</b> (bijv. EA's) of algoritmisch handelen is het gebruik van elektronische platforms voor het invoeren van handelsorders met een algoritme dat voorgeprogrammeerde handelsinstructies uitvoert, met variabelen als bijvoorbeeld timing, prijs of hoeveelheid van de order, of die in veel gevallen de order starten door een "robot" zonder menselijke tussenkomst.
                    </li>
                    <li>
                      <b>API-handel</b> is een applicatieprogrammeringsinterface die verwijst naar alle transacties die een softwareprogramma gebruiken voor wisselwerking met andere programma's. De API werkt als de tussenpersoon tussen de handelaar en de markt, als nodig met het doorgeven van orders en het ophalen van informatie.
                    </li>
                    <li>
                      <b>‘Meerdere accounts’</b> is de term die verwijst naar twee of meer accounts die zijn ingesteld door één klant voor het onjuist verkrijgen van een veelvoud van de aan de account gerelateerde voordelen aangeboden door iFOREX Europe.
                    </li>
                </ul>
                <p>Wanneer de maatschappij enige aanwijzing of vermoeden heeft, naar eigen en absoluut oordeel, van enige vorm van uitbuiting, illegale, oneerlijke, ongeoorloofde en/of misbruikte handelspraktijken, gebruikt om de klant een oneerlijk voordeel te geven, en/of van fraude, manipulatie of schending van de overeenkomsten, het beleid en de algemene voorwaarden van de maatschappij, heeft de maatschappij het recht om naar eigen goeddunken en zonder af te wijken van haar rechten onder haar overeenkomsten met de klant en de toepasselijke wetgeving, alle transacties op de betrokken accounts te annuleren, inclusief alle winsten of verliezen die daarop worden gegenereerd en/of het account te blokkeren.</p>
                <b>Fouten in koersen</b><br>
                Online handelstechnologie is niet perfect en in zeldzame gevallen kan de invoer worden verstoord. Dit kan slechts een moment duren, maar wanneer het plaatsvindt, kunnen prijzen vaak worden beïnvloed. Hoewel het verleidelijk kan zijn om een "arbitragetransactie" te plaatsen, moet u eraan denken dat de prijzen in dergelijke situaties niet de ware marktprijs weerspiegelen en uw daadwerkelijke vulling kan vele pips verwijderd zijn van de weergegeven prijs. In het geval dat transacties worden uitgevoerd tegen prijzen die niet daadwerkelijk worden aangeboden door iFOREX Europe, behoudt iFOREX Europe het recht voor om dergelijke transacties te behouden aangezien deze niet worden beschouwd als geldige transacties. Denk eraan dat deze gevallen doorgaans ongebruikelijk zijn, en door niet te handelen tijdens deze momenten, kunnen handelaars het risico vermijden dat is verbonden aan de bovenstaande scenario's.
                <br><br>
                <b>Onderhoudskosten</b><br>
                Accounts van klanten waar gedurende twaalf (12) opeenvolgende maanden geen handelsactiviteit heeft plaatsgevonden, worden 3-maandelijkse onderhoudskosten in rekening gebracht van US$15 of het gehele aandelenvermogen van de account als het aandelenvermogen minder is dan US$15.<br>Als de klant geen geld beschikbaar heeft op zijn/haar rekening, brengt iFOREX Europe geen onderhoudskosten in rekening.
                <br><br>
                Zie onze <a href="/legal/client-agreement.pdf">voorwaarden en condities</a> voor meer informatie over handelen.
              </p>
              `,
          data_id: "",
          content_after: "",
        },
      ],
    },
    {
      id: "forex",
      title: "Forex",
      tabs: [
        {
          //id: "forex_overnight_financing",
          id: "tc-view-10",
          title: "Financiering van de ene op de andere dag",
          content_before: `
                  <p>Bij het verhandelen van hefboomeffecten in Forex CFD's met iFOREX Europe, zijn uw openstaande deals onderworpen aan Overnight Financiering aan het einde van elke handelsdag. Deze financiering kan, afhankelijk van de relevante rentevoeten voor de valuta's waarin het onderliggende instrument wordt verhandeld, verhoogd worden met een opslagmarge. De mark-up voor valutaparen begint bij 0,75% en kan hoger zijn en verschillen tussen de posities Long (Kopen) en Short (Verkopen). Raadpleeg de onderstaande tabel voor de nieuwste Overnight Financiering niveaus.
                  <br><br>
                  Als de berekende overnightfinancieringspercentage positief is betekent dit dat er een relevant bedrag aan uw accountbalans wordt toegevoegd (gecrediteerd). Een negatief overnightfinancieringspercentage betekent dat er een relevant bedrag van uw accountbalans zal worden afgetrokken (gedebiteerd).
                  <br><br>
                  U vindt het relevante Overnightfinancieringspercentage, bedragen en de bijbehorende looptijden op zowel de Transactie en Limiet formulieren, onder hulpmiddelen, binnen het tabblad 'Markt informatie'. Om de overnachtfinanciering te berekenen waarmee uw rekening gedebiteerd of gecrediteerd wordt, vermenigvuldig het overnightfinancieringspercentage met de omvang van uw transactie. De looptijd van de overnight financiering voor ieder CFD wordt beschreven in het "Instrument Info Tool" onder "Overnight Financing (GMT)". De berekende waarde en het percentage van de overnight financiering van een instrument is geldig voor 1 dag. CFDs die 5 dagen per week worden gehandeld zullen worden gecrediteerd of gedebiteerd met een waarde van drie keer de getoonde waarde gedurende de laatste dag van de handelsweek van de onderliggende asset, aangezien het het gehele weekend bestrijkt. Echter, indien de genoemde CFD valuta afwijkt van de valuta van de rekening, dan zal dit worden omgerekend naar de valuta van de rekening.
                  <br><br>
                  <u><b><u>Formule</u></b></u><br><br>
                  Berekening van Overnightfinancieringspercentage wanneer u Koopt (Long Positions):
                      <br>
  
                    <div class="formula formula_f1">
                        <div class="formula-name">Overnightfinancieringspercentage</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">-
                            <div class="formula-sub">
                                <div class="formula-sub1">Rentevoet van de andere valuta - Rentevoet van de basisvaluta + Long markup</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                    </div>
                    <br>
                    Berekening van Overnightfinancieringspercentage wanneer u Verkoopt (Short Positions):
                      <br><br>
                      
                      <div class="formula formula_f2">
                        <div class="formula-name">Overnightfinancieringspercentage</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">
                            <div class="formula-sub">
                                <div class="formula-sub1">Rentevoet van de andere valuta - Rentevoet van de basisvaluta - Short markup</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                    </div>

                      <br><br>

                      Om het Overnightfinancieringspercentage te berekenen, vermenigvuldigd u het percentage met het transactiebedrag:<br><br>Overnightfinancieringspercentage = Transactiebedrag X Overnightfinancieringspercentage
                      <br><br><br>
                      <u><b><u>Voorbeelden</u></b></u><br><br>
                      <b>Voorbeeld I</b><br><br>
                      Dit voorbeeld betreft een situatie waarbij het interbancaire rente verschil HOGER is dan de markup. In dergelijke gevallen zal uw account worden gedebiteerd wanneer u koopt (long) en gecrediteerd wanneer u verkoopt (Short):
                      <br><br>
                      <ul class="list-style-dashed mb-4">
                          <li>Instrument = EUR/USD (Euro vs. US Dollar)</li>
                          <li>EUR (basisvaluta) rentevoet (op jaarbasis) = −0,37% = −0,0037</li>
                          <li>USD (andere valuta) rentevoet (op jaarbasis) = 1,08% = 0,0108</li>
                          <li>Interbank tariefverschil = 1.45% = 0.0145</li>
                          <li>Long Markup = 0.75% = 0.0075</li>
                          <li>Short Markup = 0.75% = 0.0075</li>
                          <li>Omvang transactie uitgedrukt in de andere valuta = 106,550 USD (100,000 EUR at tegen de huidige slotkoers van 1.0655)</li>
                      </ul>
                      Overnightfinancieringspercentage wanneer u Koopt (Long Positions):<br><br>
                      
                    <div class="formula formula_f3 mb-2" >
                        <div class="formula-name">Overnightfinancieringspercentage</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">-
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 - (-0.0037) + 0.0075</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">-0.0000611</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">-0.00611%</div>
                    </div>

                    Overnightfinancieringspercentage = 106,550 × (-0.0000611) = -6.51 USD, wat betekent 6.51 USD kosten per dag
                    <br><br><br>
                    Overnightfinancieringspercentage wanneer uw verkoopt (Short positions):<br><br>
                      
                      <div class="formula formula_f4 mb-2" >
                        <div class="formula-name">Overnightfinancieringspercentage</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 - (-0.0037) - 0.0075</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">0.00001944</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">0.001944%</div>
                    </div>

                    Overnightfinancieringspercentage = 106,550 × 0.00001944 = 2.07 USD krediet per dag
                    <br><br><br>
                    <b>Voorbeeld II</b><br><br>
                    Dit voorbeeld betreft een situatie waarbij het verschil tussen de Interbancaire rente hoger is dan de markup en de markeringen voor Long en Short anders zijn. In dergelijke gevallen wordt uw account elke nacht gedebiteerd ongeacht de richting van uw positie:
                    <br><br>
                    <ul class="list-style-dashed mb-4">
                       <li>Instrument = EUR/TRY (Euro vs. Turkse Lira)</li>
                       <li>EUR (basisvaluta) rentevoet (op jaarbasis) = −0,37% = −0,0037</li>
                       <li>TRY (andere valuta) rentevoet (op jaarbasis) = 22,75% = 0,2275</li>
                       <li>Interbank tariefverschil = 23.12% = 0.2312</li>
                       <li>Long Markup = 0.75% = 0.0075</li>
                       <li>Short Markup = 14.00% = 0.14</li>
                       <li>Omvang transactie uitgedrukt in de andere valuta = 620,000 TRY (100,000 EUR tegen de huidige slotkoers van 6.2000)</li>
                    </ul>
                    Overnightfinancieringspercentage wanneer u Koopt (Long Positions):<br><br>
                      
                        <div class="formula formula_f5 mb-2" >
                            <div class="formula-name">Overnightfinancieringspercentage</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">-
                                <div class="formula-sub">
                                    <div class="formula-sub1">0.2275 - (-0.0037) + 0.0075</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">-0.000663</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">-0.0663%</div>
                        </div>

                    
                        Overnightfinancieringspercentage = 620,000 × (-0.000663) = -411 TRY, wat betekent 411 TRY kosten per dag (≅80 USD)
                        <br><br><br>
                        Overnightfinancieringspercentage wanneer uw verkoopt (Short positions):<br><br>
                      
                      <div class="formula formula_f6 mb-2" >
                            <div class="formula-name">Overnightfinancieringspercentage</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">
                                <div class="formula-sub">
                                    <div class="formula-sub1">0.2275 - (-0.0037) - 0.14</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">0.000253</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">0.0253%</div>
                        </div>


                        Overnight financiering bedrag = 620.000 x (0.000253) = 157 TRY, dat wil zeggen 157 TRY-tegoed per dag (≅30 USD)
                        <br><br><br>
                        <b>Voorbeeld III</b><br><br>
                        Dit voorbeeld betreft een situatie waarbij het interbancaire rente verschil LAGER is dan de negatieve markup. In dergelijke gevallen zal uw account worden gedebiteerd wanneer u verkoopt (short gaat) en gecrediteerd wanneer u koopt (Long gaat):
                        <ul class="list-style-dashed mt-4 mb-4">
                           <li>Instrument = USD/JPY (US Dollar vs. Japonský jen)</li>
                           <li>USD (basisvaluta) rentevoet (op jaarbasis) = 1,08% = 1,08</li>
                           <li>JPY (andere valuta) rentevoet (op jaarbasis) = −0,09% = −0,0009</li>
                           <li>Interbank tariefverschil = -1.17% = -0.0117</li>
                           <li>Long Markup = 0.75% = 0.0075</li>
                           <li>Short Markup = 0.75% = 0.0075</li>
                           <li>Omvang transactie uitgedrukt in de andere valuta = 10,341,000 JPY (100,000 USD tegen de huidige slotkoers van 103.41)</li>
                        </ul>
                        Overnightfinancieringspercentage wanneer u Koopt (Long Positions):<br><br>
                      
                      
                      <div class="formula formula_f7 mb-2" >
                            <div class="formula-name">Overnightfinancieringspercentage</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">-
                                <div class="formula-sub">
                                    <div class="formula-sub1">(-0.0009) - 0.0108 + 0.0075</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">0.00001167</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">0.001167%</div>
                        </div>


                        Overnightfinancieringspercentage = 10,341,000 × 0.00001167 = 120.65 JPY krediet per dag (≅1.1 USD)
                        <br><br><br>
                        Overnightfinancieringspercentage wanneer uw verkoopt (Short positions):<br><br>
                      
                      <div class="formula formula_f8 mb-2" >
                            <div class="formula-name">Overnightfinancieringspercentage</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">
                                <div class="formula-sub">
                                    <div class="formula-sub1">(-0.0009) - 0.0108 - 0.0075</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">-0.0000533</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">-0.00533%</div>
                        </div>

                        Overnightfinancieringspercentage = 10,341,000 ×(-0.0000533) = -551.52 JPY, wat betekent 551.52 JPY kosten per dag (≅5.3 USD)
                  </p>`,
  
          data_id: "OvernightFinancing",
          content_after: `<p>* Het kan maximaal 15 minuten duren om de overnight financiering te verwerken aan het einde van de handelsdag, waarna uw account correct wordt gecrediteerd of gedebiteerd.</p>`,
          table_titles: [
            "Instrument",
            "Dagelijkse Overnightfinancieringspercentage (Verkoop)",
            "Dagelijkse Overnightfinancieringspercentage (Koop)",
            "Overnachtfinanciering (GMT)*",
          ],
          view_id: ["Forex"],
        },
      ],
    },
    {
      id: "index_commodity_and_crypto_cfds",
      title: "Index, Grondstoffen en Crypto CFD's",
      tabs: [
        {
          //id: "index_overnight_financing",
          id: "tc-view-11",
          title: "Financiering van de ene op de andere dag",
          content_before: `
              <p>Bij het verhandelen van Index, Grondstof en Crypto CFDs met iFOREX Europe zijn uw open transacties onderhevig aan overnachtfinanciering aan het einde van elke handelsdag. Deze overnachtfinanciering kan onderworpen zijn aan krediet of debet, berekend op basis van relevante rentetarieven voor de valuta waarin het onderliggende instrument word verhandeld, plus een markup. De markup voor cryptocurrencies kan aanzienlijk hoger liggen als gevolg van de extreme marktomstandigheden. Raadpleeg onderstaande tabel voor de meest recente niveaus voor de overnachtfinanciering.
              <br><br>
              Als de berekende overnightfinancieringspercentage positief is betekent dit dat er een relevant bedrag aan uw accountbalans wordt toegevoegd (gecrediteerd). Een negatief overnightfinancieringspercentage betekent dat er een relevant bedrag van uw accountbalans zal worden afgetrokken (gedebiteerd).
              <br><br>
              U vindt het relevante Overnightfinancieringspercentage, bedragen en de bijbehorende looptijden op zowel de Transactie en Limiet formulieren, onder hulpmiddelen, binnen het tabblad 'Markt informatie'. Om de overnachtfinanciering te berekenen waarmee uw rekening gedebiteerd of gecrediteerd wordt, vermenigvuldig het overnightfinancieringspercentage met de omvang van uw transactie. De looptijd van de overnight financiering voor ieder CFD wordt beschreven in het "Instrument Info Tool" onder "Overnight Financing (GMT)". De berekende waarde en het percentage van de overnight financiering van een instrument is geldig voor 1 dag. CFDs die 5 dagen per week worden gehandeld zullen worden gecrediteerd of gedebiteerd met een waarde van drie keer de getoonde waarde gedurende de laatste dag van de handelsweek van de onderliggende asset, aangezien het het gehele weekend bestrijkt. Echter, indien de genoemde CFD valuta afwijkt van de valuta van de rekening, dan zal dit worden omgerekend naar de valuta van de rekening.
              <br><br>
              <u><b><u>Formule</u></b></u><br><br>
              Berekening van Overnightfinancieringspercentage wanneer u Koopt (Long Positions):<br>
                  
                  <div class="formula formula_f9 mb-2">
                    <div class="formula-name">Overnightfinancieringspercentage</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">Rente + Markup</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>
                <br>
                Berekening van Overnightfinancieringspercentage wanneer u Verkoopt (Short Positions):<br><br>
                  
                  <div class="formula formula_f10 mb-2">
                    <div class="formula-name">Overnightfinancieringspercentage</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">Rente - Markup</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>

                Om het Overnightfinancieringspercentage te berekenen, vermenigvuldigd u het percentage met het transactiebedrag:<br><br>Overnightfinancieringspercentage = Transactiebedrag X Overnightfinancieringspercentage
                <br><br><br>
                <u><b><u>Voorbeelden</u></b></u><br><br>
                <b>Voorbeeld I</b><br><br>
                Dit voorbeeld betreft een situatie waarbij de interbancaire rente HOGER is dan de markup. In dergelijke gevallen zal uw account worden gedebiteerd wanneer u koopt (long) en gecrediteerd wanneer u verkoopt (Short):
                <br><br>
                <ul class="list-style-dashed">
                   <li>Instrument = Brazil Ibovespa</li>
                   <li>Braziliaanse real (BRL) rentevoet (op jaarbasis) = 9,567% = 0,09567</li>
                   <li>Markup = 2.5% = 0.025</li>
                   <li>Omvang transactie uitgedrukt in valuta = 127,380 BRL (2 indexcontracten tegen de huidige slotkoers van 63690 per contract)</li>
                </ul>
                <br>
                Overnightfinancieringspercentage wanneer u Koopt (Long Positions):<br><br>
                  
                  <div class="formula formula_f11 mb-2">
                    <div class="formula-name">Overnightfinancieringspercentage</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">0.09567 + 0.025</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.0003351944</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.03351944%</div>
                </div>

                Overnightfinancieringspercentage = 127,380 × (-0.0003351944) = -42.70 BRL, wat betekent 42.70 BRL kosten per dag (≅13.58 USD)
                <br><br><br>
                Overnightfinancieringspercentage wanneer uw verkoopt (Short positions):<br><br>
                  
                  <div class="formula formula_f12 mb-2">
                    <div class="formula-name">Overnightfinancieringspercentage</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">0.09567 - 0.025</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">0.00019630556</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">0.019630556%</div>
                </div>

                Overnightfinancieringspercentage = 127,380 × 0.00019630556 = 25 BRL krediet per dag (≅7.95 USD)
                <br><br><br>
                <b>Voorbeeld II</b><br><br>
                Dit voorbeeld betreft een situatie waarbij de interbancaire rente LAGER is dan de markup. In dergelijke gevallen wordt uw account elke nacht gedebiteerd ongeacht de richting van uw positie:
                <br><br>
                <ul class="list-style-dashed">
                   <li>Instrument = Oil (Crude Light WTI)</li>
                   <li>Amerikaanse dollar (USD) rentevoet (op jaarbasis) = 1,08% = 0,0108</li>
                   <li>Markup = 2.5% = 0.025</li>
                   <li>Omvang transactie uitgedrukt in valuta = 53,250 USD (1,000 Olievaten tegen de huidige slotkoers van 53.25 USD per vat)</li>
                </ul>
                <br><br>
                Overnightfinancieringspercentage wanneer u Koopt (Long Positions):
                  <br>
                  <br>

                  <div class="formula formula_f13 mb-2">
                        <div class="formula-name">Overnightfinancieringspercentage</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f1">-
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 + 0.025</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">-0.00009944</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">-0.009944%</div>
                    </div>

                    Overnightfinancieringspercentage = 53,250 × (-0.00009944) = -5.30 USD, wat betekent 5.30 USD kosten per dag
                    <br><br><br>
                    Overnightfinancieringspercentage wanneer uw verkoopt (Short positions):<br><br>
                  
                  <div class="formula formula_f14 mb-2">
                        <div class="formula-name">Overnightfinancieringspercentage</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f1">
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 - 0.025</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">-0.00003944</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">-0.003944%</div>
                    </div>

                    Overnightfinancieringspercentage = 53,250 × (-0.00003944) = -2.10 USD, wat betekent 2.10 USD kosten per dag
                  <br><br>
                  
                 
              </p>`,
          data_id: "OvernightFinancing",
          content_after: `<p>* Het kan maximaal 15 minuten duren om de overnight financiering te verwerken aan het einde van de handelsdag, waarna uw account correct wordt gecrediteerd of gedebiteerd.</p>`,
          table_titles: [
            "Instrument",
            "Dagelijkse Overnightfinancieringspercentage (Verkoop)",
            "Dagelijkse Overnightfinancieringspercentage (Koop)",
            "Overnachtfinanciering (GMT)*",
          ],
          view_id: ["Index", "Commodity", "Crypto"],
        },
        {
        //id: "contracts_rollover_dates",
        id: "tc-view-3",
          title: "Doorroldata van Contracten",
          content_before: `<p>
                  Ieder CFD dat is gebaseerd op een futurecontract (zoals bijv. grondstoffen en indexen) heeft een doorroldatum.
                  <br><br>
                  Bij het bereiken van de doorroldatum van het instrument worden alle op futurecontracten gebaseerde open CFD-posities doorgerold naar het volgende contract, zodat de posities bij het nieuwe futurecontract open blijven.
                  <br><br>
                  Bij het uitvoeren van een dergelijke roll-over, zal de P&amp;L (profit/Loss) van de positie het prijsverschil tussen de verlopen en nieuwe contractprijzen uitdrukken evenals een mark-upspreiding. Alle bijbehorende Limiet order niveaus worden automatisch aangepast volgens de nieuwe toekomstige contractprijs.
                  <br><br>
                  Bijvoorbeeld, als de laatste prijs van de WTI Oil Februari-contract bijvoorbeeld $50.125 bedraagt en de marktprijs van het volgende contract (Maart) op dat moment $50.805 bedraagt, dan wordt het prijsniveau van alle uitstaande limietorders bijgewerkt naar boven met $0.68.
                  <br><br>
                  De doorroldata van contracten zijn afhankelijk van het verhandelde instrument en de onderstaand beschreven doorroldata zijn uitsluitend van toepassing op de CFD van iFOREX Europe:
                  </p>`,
  
          data_id: "FuturesRollover",
          content_after: ``,
          table_titles: ["Contract maand", "Contract rollover dag en tijd (GMT)"],
          view_id: ["Commodity", "Index"],
          products: ["Grondstoffen", "Indices"],
        },
      ],
    },
    {
      id: "Share and ETF CFDs",
      title: "Aandeel en ETF CFDs",
      tabs: [
        {
          //id: "shares_overnight_financing",
          id: "tc-view-12",
          title: "Financiering van de ene op de andere dag",
          content_before: `<p>
                  Bij het verhandelen van Aandelen en ETF CFDs met iFOREX Europe zijn uw open transacties onderhevig aan overnachtfinanciering aan het einde van elke handelsdag. Deze overnachtfinanciering kan onderworpen zijn aan krediet of debet, berekend op basis van relevante rentetarieven voor de valuta waarin het onderliggende instrument word verhandeld, plus een markup. Raadpleeg onderstaande tabel voor de meest recente niveaus voor de overnachtfinanciering.
                  <br><br>
                  Als de berekende overnightfinancieringspercentage positief is betekent dit dat er een relevant bedrag aan uw accountbalans wordt toegevoegd (gecrediteerd). Een negatief overnightfinancieringspercentage betekent dat er een relevant bedrag van uw accountbalans zal worden afgetrokken (gedebiteerd).
                  <br><br>
                  U vindt het relevante Overnightfinancieringspercentage, bedragen en de bijbehorende looptijden op zowel de Transactie en Limiet formulieren, onder hulpmiddelen, binnen het tabblad 'Markt informatie'. Om de overnachtfinanciering te berekenen waarmee uw rekening gedebiteerd of gecrediteerd wordt, vermenigvuldig het overnightfinancieringspercentage met de omvang van uw transactie. De looptijd van de overnight financiering voor ieder CFD wordt beschreven in het "Instrument Info Tool" onder "Overnight Financing (GMT)". De berekende waarde en het percentage van de overnight financiering van een instrument is geldig voor 1 dag. CFDs die 5 dagen per week worden gehandeld zullen worden gecrediteerd of gedebiteerd met een waarde van drie keer de getoonde waarde gedurende de laatste dag van de handelsweek van de onderliggende asset, aangezien het het gehele weekend bestrijkt. Echter, indien de genoemde CFD valuta afwijkt van de valuta van de rekening, dan zal dit worden omgerekend naar de valuta van de rekening.
                  <br><br>
                  <u><b><u>Formule</u></b></u><br><br>
                  Berekening van Overnightfinancieringspercentage wanneer u Koopt (Long Positions):
                  <br>
                  
                  <div class="formula formula_f15 mb-2">
                    <div class="formula-name">Overnightfinancieringspercentage</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">Rente + Markup</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>
                <br>
                Berekening van Overnightfinancieringspercentage wanneer u Verkoopt (Short Positions):

                <br><br>

                <div class="formula formula_f16 mb-2">
                    <div class="formula-name">Overnightfinancieringspercentage</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">Rente - Markup</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>


                Om het Overnightfinancieringspercentage te berekenen, vermenigvuldigd u het percentage met het transactiebedrag:<br><br>Overnightfinancieringspercentage = Transactiebedrag X Overnightfinancieringspercentage
                <br><br><br>
                <u><b><u>Voorbeelden</u></b></u><br><br>
                <b>Voorbeeld I</b><br><br>
                Dit voorbeeld betreft een situatie waarbij de interbancaire rente HOGER is dan de markup. In dergelijke gevallen zal uw account worden gedebiteerd wanneer u koopt (long) en gecrediteerd wanneer u verkoopt (Short):
                <br><br>
                <ul class="list-style-dashed mb-4">
                   <li>Instrument = Gazprom (GAZP)</li>
                   <li>Russische roebel (RUB) rentevoet (op jaarbasis) = 9,5% = 0,095</li>
                   <li>Markup = 5% = 0.05</li>
                   <li>Omvang transactie uitgedrukt in valuta = 2459,000 RUB (20,000 Aandelen tegen de huidige slotkoers van 122.65 RUB per aandeel)</li>
                </ul>

                Overnightfinancieringspercentage wanneer u Koopt (Long Positions):<br><br>
                  
                  
                <div class="formula formula_f17 mb-2">
                    <div class="formula-name">Overnightfinancieringspercentage</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">0.095 + 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.0004</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.04%</div>
                </div>

                Overnightfinancieringspercentage = 2,459,000 × (-0.0004) = -983.60 RUB, wat betekent 983.60 RUB kosten per dag (≅17.52 USD)
                <br><br><br>
                Overnightfinancieringspercentage wanneer uw verkoopt (Short positions):<br><br>

                  <div class="formula formula_f18 mb-2">
                    <div class="formula-name">Overnightfinancieringspercentage</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">0.095 - 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">0.000125</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">0.0125%</div>
                </div>


                Overnightfinancieringspercentage = 2,459,000 × 0.000125= 307.38 RUB krediet per dag (≅5.48 USD)
                <br><br><br>
                <b>Voorbeeld II</b><br><br>
                Dit voorbeeld betreft een situatie waarbij de interbancaire rente LAGER is dan de markup. In dergelijke gevallen wordt uw account elke nacht gedebiteerd ongeacht de richting van uw positie:
                <br><br>
                <ul class="list-style-dashed mb-4">
                    <li>Instrument = Apple (AAPL)</li>
                    <li>Amerikaanse dollar (USD) rentevoet (op jaarbasis) = 1,08% = 0,0108</li>
                    <li>Markup = 5% = 0.05</li>
                    <li>Omvang transactie uitgedrukt in valuta = 70,600 USD (500 Aandelen tegen de huidige slotkoers van 141.20 USD per aandeel)</li>
                </ul>
  
                Overnightfinancieringspercentage wanneer u Koopt (Long Positions):<br><br>

                  <div class="formula formula_f19 mb-2">
                    <div class="formula-name">Overnightfinancieringspercentage</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">0.0108 + 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.000169</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.0169%</div>
                </div>
                  
                Overnightfinancieringspercentage = 70,600 × (-0.000169) = -11.93 USD, wat betekent 11.93 USD kosten per dag
                <br><br><br>
                Overnightfinancieringspercentage wanneer uw verkoopt (Short positions):<br><br>
                  
                <div class="formula formula_f20 mb-2">
                    <div class="formula-name">Overnightfinancieringspercentage</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">0.0108 - 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.000109</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.0109%</div>
                </div>


                Overnightfinancieringspercentage = 70,600 × (-0.000109) = -7.70 USD, wat betekent 7.70 USD kosten per dag
            
              </p>`,
          data_id: "OvernightFinancing",
          content_after: `<p>* Het kan maximaal 15 minuten duren om de overnight financiering te verwerken aan het einde van de handelsdag, waarna uw account correct wordt gecrediteerd of gedebiteerd.</p>`,
          table_titles: [
            "Instrument",
            "Dagelijkse Overnightfinancieringspercentage (Verkoop)",
            "Dagelijkse Overnightfinancieringspercentage (Koop)",
            "Overnachtfinanciering (GMT)*",
          ],
          view_id: [ "Shares", "ETF"],
        },
        {
          //d: "dividends",
          id: "tc-view-7",
          title: "Dividenden",
          content_before: `<p>
                    In geval van een verdeling van cash dividenden met betrekking tot een CFD-aandeel, vindt aan het einde van de werkdag voorafgaande aan de ex-dividenddatum een dividendaanpassing op het Saldo van de Klant plaats met betrekking tot de onderliggende Posities van de aandelen van de Klant. De dividendaanpassing wordt berekend op basis van de hoogte van het dividend, de omvang van de positie van de Klant en of het om een Koop- of Verkooptransactie gaat, waarbij het saldo van de Klant met betrekking tot long (koop) posities met de aanpassing wordt gecrediteerd en het saldo van de Klant met betrekking tot short (verkoop) posities met de aanpassing wordt gedebiteerd. Het Saldo van de Klant wordt buiten de handelsuren van het onderliggende aandeel en voor opening van de volgende beursdag van het aandeel voor de dividenden gecrediteerd of gedebiteerd, afhankelijk van het feit of de Klant de betreffende Positie op het moment van de dividendaanpassing aanhoudt. Gedurende deze periode zal het bedrijf, om de juiste waarde van het Actueel vermogen van de Klant tot de opening van de volgende beursdag te behouden, de Positie van de Klant voor het op het Saldo van Klant gedebiteerde of gecrediteerde dividendbedrag aanpassen.
                    <br><br>
                    <u><u>Voorbeeld</u>:</u><br>
                    Coca-Cola geeft een dividend uit van 0,35 USD per aandeel.<br>
                    De ex-dividenddatum is 29 november en de afwikkelingsdatum in iFOREX Europe is 28 november om 22:05 uur GMT.<br>
                    De slotkoers voor de afwikkeling is 41,65 USD.<br>
                    Een klant met een long positie van 5000 aandelen wordt gecrediteerd voor 0,35 x 5000 = 1750 USD als zijn deal op de afwikkelingsdatum open staat.
                    <br>
                    Hetzelfde bedrag wordt op het saldo van een klant met een short positie in rekening gebracht.
                    <br>
                    De aandelenprijs wordt gedurende de uren na het sluiten van de beurs aangepast van 41,65 naar 41,30, wat gelijk is aan de laatste aandelenprijs minus het dividendbedrag.
                      </p>`,
          data_id: "CorporateActions",
          content_after: "",
          no_information:"Er is momenteel geen informatie over toekomstige dividenden",
          table_titles: [
            "Aandeel / ETF",
            "Markt",
            "Dividendbedrag",
            "Datum en tijd (GMT)",
          ],
          view_id: "1",
        },
        {
          //id: "corporate_actions",
          id: "tc-view-1",
          title: "Aandelen dividenden, aandelensplitsingen en andere corporate actions",
          content_before: `<p>
                Corporate Actions zijn bepaalde gebeurtenissen die de waarde van het aandeel van een beursgenoteerd bedrijf beïnvloeden. Tenzij hieronder anders vermeld met betrekking tot specifieke Corporate Actions, zal iFOREX Europe bij het plaatsvinden van een Corporate Action in een specifiek aandeel, alle open posities van de betreffende CFD('s) liquideren, inclusief, indien nodig, het verwijderen van limietorder(s) van dergelijke CFD('s).
                <br><br>
                Corporate Actions in iFOREX Europe zijn: aanbod van rechten, delisting en iedere andere gebeurtenis die een belangrijk effect heeft of kan hebben op de aandelenprijs (inclusief belangrijke bedrijfsaankondigingen, overnames, fusies, insolventie, enz.).
                <br><br>

                <b>Aandelen dividenden</b><br>

                Aandelen dividenden op de beurs veranderen de totale waarde van aandelen voor degenen die ze bezitten niet, maar veranderen het aantal aandelen en hun prijs.<br>
                U ontvangt de 'Aanpassingsfactor' voor elk aandeel dat u bezit.<br>
                Elke openstaande transactie en/of limietorder tijdens de datum en tijd van het aandelendividend zal dienovereenkomstig worden aangepast in hoeveelheid, prijs en bijbehorende limieten (inclusief het rekeningsaldo vanwege vereiste winst-/verliesaanpassingen, indien van toepassing).<br>
                Bijvoorbeeld, in een aandelencorrectie met een aanpassingsfactor van 1,8 wordt 1 aandeel na het evenement 1,8 aandelen en wordt de prijs gedeeld door 1,8, waardoor de totale waarde van de aandelen ongewijzigd blijft.<br>
                Bijv.: 1 aandeel met een prijs van $1.000 wordt 1,8 aandelen met een prijs van $555,56 na het evenement: 1×$1.000 = 1,8×$555,56 = $1.000 waarde.<br><br>


                <strong>
                Specifieke regels voor stock splits en reversed stock splits
                </strong>
                <br>
                Bij stock splits en reversed stock splits op de beurs verandert niet de totale waarde van de aandelen voor degenen die ze houden, maar wel het aantal aandelen en hun prijs. Deze splitsingen worden gewoonlijk uitgevoerd wanneer de aandelenprijs te hoog of te laag is. Als een open deal/limiet te maken krijgt met een stock split, worden het bedrag, de koers en de bijbehorende limiet(en) dienovereenkomstig aangepast (inclusief het saldo van de rekening, als gevolg van vereiste PL-aanpassingen, indien van toepassing).
                <br><br>
                Bijvoorbeeld, bij een 1:10-splitsing wordt 1 aandeel na de gebeurtenis opgesplitst in 10 aandelen en wordt de prijs gedeeld door 10, waarbij de totale waarde van de aandelen ongewijzigd blijft. Bijvoorbeeld: 1 aandeel met een prijs van $1.000 wordt na de splitsing 10 aandelen met een prijs van $100 (per aandeel): 1x $1.000 = 10 x $100 = $1.000 waarde.
                <br><br>
                Hieronder vindt u een lijst met de aankomende corporate actions:
              </p>`,
          data_id: "CorporateActions",
          content_after: "",
          no_information:"hier is momenteel geen informatie over toekomstige 'Corporate Actions'",
          table_titles: ["Aandeel / ETF", "Markt", "Type", "Datum en tijd (GMT)"],
        },
        {
          //id: "earnings_reports",
          id: "tc-view-22",
          title: "Winstrapporten",
          content_before: `<p>
              Een winstrapport is een periodieke indiening door openbare bedrijven om hun prestaties te melden. Door driemaandelijkse winstrapporten te analyseren, kunnen beleggers de financiële gezondheid van het bedrijf meten. De aankondiging van winsten voor een bedrijf, met name voor een populair bedrijf met een hoge marktkapitalisatie, kan zijn aandelenkoersen beïnvloeden, waardoor het kan fluctueren op dagen waarop dergelijke driemaandelijkse winstrapporten worden vrijgegeven.
              <br><br>
              Om die reden wordt de maximale blootstelling van de betreffende aandelen verlaagd naar $10.000 gedurende de gehele publicatieperiode.
               </p>`,
          data_id: "",
          content_after: "",
        },
      ],
    },
  ];
  
  export { content };
  